import { call, fork, put, takeEvery } from 'redux-saga/effects';

import {
  getInvestDetailDataFail,
  getInvestDetailDataSuccess,
  getInvestDetailHitDataFail,
  getInvestDetailHitDataSuccess,
  getInvestDetailPastHitsDataFail,
  getInvestDetailPastHitsDataSuccess,
  NS_GET_INVEST_DETAIL_DATA,
  NS_GET_INVEST_DETAIL_HIT_DATA,
  NS_GET_INVEST_DETAIL_PASTHITS_DATA
} from '../../redux/actions/ns/investigationDetail';

import {
  getInvestDetailData,
  getInvestDetailHits,
  getInvestDetailPastHits
} from '../../services/ns/investigationDetail';

function* getInvestDetailDataWorker(payload) {
  const {
    permissions: {
      isCustomerProfileAllowed = true,
      isAlertDetailsAllowed = true
    }
  } = payload;

  try {
    const alertDetailResponse = yield call(getInvestDetailData, payload);

    if (alertDetailResponse) {
      const alertDetails = alertDetailResponse.alert;
      const hitsPayload = {
        clusterVersion: alertDetails.clusterVersion,
        alertType: alertDetails.alertType,
        alertId: alertDetails.alertId
      };

      let hitsResponse = {};

      if (isAlertDetailsAllowed) {
        hitsResponse = yield call(getInvestDetailHits, hitsPayload);
      }

      const response = {
        alert: {
          ...alertDetails
        },
        hits: hitsResponse.list || [],
        totalCount: hitsResponse.totalCount
      };
      response.hits = response.hits.map((hitsObj) => {
        if (
          !hitsObj.hit.watchlistGender ||
          hitsObj.hit.watchlistGender === 'NULL'
        ) {
          hitsObj.hit.watchlistGender = '-';
        }
        return hitsObj;
      });
      yield put(getInvestDetailDataSuccess(response));
    }
  } catch (error) {
    yield put(
      getInvestDetailDataFail({
        message: 'Something went wrong, please try again..'
      })
    );
  }
}

function* getInvestDetailHitsDataWorker(payload) {
  try {
    const response = yield call(getInvestDetailHits, payload);
    yield put(getInvestDetailHitDataSuccess(response));
  } catch (error) {
    yield put(
      getInvestDetailHitDataFail({
        message: 'Something went wrong, please try again..'
      })
    );
  }
}

function* getInvestDetailPastHitsDataWorker(payload) {
  try {
    const response = yield call(getInvestDetailPastHits, payload);
    yield put(getInvestDetailPastHitsDataSuccess(response));
  } catch (error) {
    yield put(
      getInvestDetailPastHitsDataFail({
        message: 'Something went wrong, please try again..'
      })
    );
  }
}

export function* watchGetInvestDetailPastHitsData() {
  yield takeEvery(NS_GET_INVEST_DETAIL_PASTHITS_DATA, function* ({ payload }) {
    yield fork(getInvestDetailPastHitsDataWorker, payload);
  });
}

export function* watchGetInvestDetailData() {
  yield takeEvery(NS_GET_INVEST_DETAIL_DATA, function* ({ payload }) {
    yield fork(getInvestDetailDataWorker, payload);
  });
}

export function* watchGetInvestDetailHitsData() {
  yield takeEvery(NS_GET_INVEST_DETAIL_HIT_DATA, function* ({ payload }) {
    yield fork(getInvestDetailHitsDataWorker, payload);
  });
}
